export default __webpack_public_path__ + "static/media/4dc8e5ca7e4c4d72483e7a59e5af7a77.png";